import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { Spinner } from 'libs.nucleus';
import { AuthContext } from 'libs.react_internal';
/**
 * Resolves the redirect for the `/` index route.
 *
 * External sections (e.g. Agents Studio on its own subdomain) expose an absolute URL as their
 * `path`, which `<Navigate>` would treat as a relative path and append to the current origin,
 * producing a malformed `https://a.medable.com/https://b.medable.com/...`. Those need a full-page
 * navigation instead. A `location` query param means the user deep-linked to documentation and is
 * resolved through the auth context. Everything else is a normal in-app client-side redirect.
 *
 * Tying this to rendering the `/` route (rather than an `isLoggedIn` effect) makes it fire
 * regardless of how the user reaches `/` — fresh load, post-login navigate, or workspace switch.
 */
export const DefaultSectionRedirect = ({ section }) => {
    const { redirectToDefaultPage } = useContext(AuthContext);
    const [searchParams] = useSearchParams();
    const hasLocationParam = searchParams.has('location');
    const externalUrl = section.externalUrl ? section.redirectTo : undefined;
    useEffect(() => {
        if (hasLocationParam) {
            void redirectToDefaultPage();
        }
        else if (externalUrl) {
            window.location.replace(externalUrl);
        }
    }, [hasLocationParam, externalUrl, redirectToDefaultPage]);
    if (hasLocationParam || externalUrl) {
        return _jsx(Spinner, { wrapper: 'full' });
    }
    return _jsx(Navigate, { to: section.path, replace: true });
};
